import { createFileRoute } from "@tanstack/react-router";
import { ConnectionDetail } from "../../../features/connections/connection-detail";

export const Route = createFileRoute("/_authed/$org/$project/connections/$name")({ component: ConnectionPage });

function ConnectionPage() {
  const { org, project, name } = Route.useParams();
  return <ConnectionDetail scope={{ org, project }} name={name} />;
}
